import { z } from "zod";

import {
  BinSizeEnum,
  CleanupTypeEnum,
  ServiceTaskTypeEnum,
  TaskDriverStatusEnum,
} from "@/domain/models/common";
import { FirebaseDateType } from "@/domain/models/firebase";
import { JobConnectedTaskType, TasksType } from "@/domain/models/job";

import { DateType } from "../utils/date";

export const taskFilterSchema = z.object({
  dueAtStart: z.date().optional(),
  dueAtEnd: z.date().optional(),
  completed: z.boolean().optional(),
  taskIds: z.array(z.nativeEnum(ServiceTaskTypeEnum)).optional(),
  assignedTo: z.string().optional(),
  started: z.boolean().optional(),
  hasDumped: z.boolean().optional(),
  needToDump: z.boolean().optional(),
  dueAtNotNull: z.boolean().optional(),
});

export type TaskFiltersType = z.infer<typeof taskFilterSchema>;

export type JobServiceTaskBaseType = {
  jobId: string;
  serviceId: string;
  taskId: ServiceTaskTypeEnum;
};

export type AssignTaskToDriverParamsType = JobServiceTaskBaseType & {
  assignedTo: string;
  selectedDate: DateType;
};

export type UpdateTaskDueAtParamsType = JobServiceTaskBaseType & {
  dueAt: FirebaseDateType;
};

export type UpdateTaskParamsType = JobServiceTaskBaseType & Partial<TasksType>;

export type UpdateTaskCleanupParamsType = JobServiceTaskBaseType & {
  cleanupType: CleanupTypeEnum;
};

export type GetTaskPropsType = {
  jobId: string;
  serviceId: string;
  taskId: ServiceTaskTypeEnum;
};

export const DASHBOARD_TASKS_ORDER = [
  ServiceTaskTypeEnum.DROPBIN,
  ServiceTaskTypeEnum.WAITANDLOADBIN,
  ServiceTaskTypeEnum.PICKUPBIN,
  ServiceTaskTypeEnum.EXCHANGEBIN,
  ServiceTaskTypeEnum.DUMPANDRETURNBIN,
  ServiceTaskTypeEnum.JUNKREMOVAL,
];

export type StartTaskFunctionRequestType = JobServiceTaskBaseType & {
  shouldNotifyClient: boolean;
};

export type StartTaskFunctionResultType = JobServiceTaskBaseType & {
  started: boolean;
  startedUpdatedAt: FirebaseDateType;
  driverFlowStatus: TaskDriverStatusEnum;
};

export type UpdateBinSizeParamsType = JobServiceTaskBaseType & {
  size: BinSizeEnum;
};

export type UpdateConnectedTaskType = JobServiceTaskBaseType & {
  connectedTask: JobConnectedTaskType | null;
};
